import type { KeyboardInputItem } from '@vedalib/editor/lib/elements'
import { TestAnswerFeedbackType } from '@vedalib/editor/lib/elements'
import React from 'react'
import { chainName } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldArray, FieldSegmented, FieldSelect, FormField } from 'components/formKit'
import { useHiddenTestFeedback } from 'services/Branding/fieldConfigs/useFieldConfigs'
import { t } from 'services/Translation'
import { getEnumOption } from 'utils/enum'

import TestKeyboardInputFormValueItem from './TestKeyboardInputFormValueItem'
import type { TestKeyboardInputValueFormType } from './testKeyboardInputTypes'

const ANSWER_FEEDBACK = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'answerFeedback',
  label: t('elements.testAnswerFeedback.form.answerFeedback'),
  defaultValue: true,
})

const DISPLAY_FEEDBACK = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'displayFeedback',
  label: t('elements.testAnswerFeedback.form.displayFeedback'),
  defaultValue: true,
})

const GENERAL_TYPE_FB = genElementValueField({
  as: FieldSelect<TestAnswerFeedbackType>,
  name: 'generalTypeFb',
  label: t('elements.testAnswerFeedback.form.generalTypeFb'),
  defaultValue: TestAnswerFeedbackType.validation,
  props: {
    options: [
      getEnumOption('TestFeedbackType', TestAnswerFeedbackType.validation),
      getEnumOption('TestFeedbackType', TestAnswerFeedbackType.info),
    ],
  },
  useConfigs: [useHiddenTestFeedback],
})

const ITEMS = genElementValueField({
  as: FieldArray<KeyboardInputItem>,
  name: 'items',
  props: {
    min: 1,
    max: 15,
    defaultItem: { label: '', points: 1 },
    RenderItem: TestKeyboardInputFormValueItem,
  },
})

const TestKeyboardInputFormValue: TestKeyboardInputValueFormType = ({ name }) => (
  <Padding bottom gap sides>
    <FormField config={chainName(name, ANSWER_FEEDBACK)} />
    <FormField config={chainName(name, DISPLAY_FEEDBACK)} />
    <FormField config={chainName(name, GENERAL_TYPE_FB)} />
    <FormField config={chainName(name, ITEMS)} />
  </Padding>
)

export default TestKeyboardInputFormValue
